// extracted by mini-css-extract-plugin
export default {"ModalTitleHeader":"ModalTitleBar_ModalTitleHeader__S4vXl"};